// extracted by mini-css-extract-plugin
module.exports = {"pwd-change-alt":"change_pwd_pwd-change-alt__1dWL0"};